import PageTitle from "../../global/components/PageTitle";
import { Box, Divider } from "@mui/material";
import LicenseDataAccordion from "./components/LicenseDataAccordion";
import LicensesDataTable from "./components/LicensesDataTable";
import SupportAccordion from "../../global/components/SupportAccordion";
import ActivatedPcsTable from "./components/ActivatedPcsTable";

const Licenses = () => {
  return (
    <Box sx={{ maxWidth: 1000 }}>
      <PageTitle title="Lizenz-Info" />
      <Divider />
      <LicenseDataAccordion />
      <SupportAccordion />
      <h3>Gekaufte Module</h3>
      <LicensesDataTable />
      <h3>PC - Aktivierungen</h3>
      <ActivatedPcsTable />
    </Box>
  );
};

export default Licenses;
